import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Dialog, DialogContent, DialogContentText, CircularProgress } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
const useStyles = makeStyles(theme => ({
    paper: {
        backgroundColor: "rgba(0,0,0,0)",
        opacity: "1",
        boxShadow: "none",
        overflow: "hidden"
    },
    backdrop: {
        background: "rgba(0,0,0,0)"
    },
    container: {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        position: "absolute",
        textAlign: "center"
    },
    icon: {
        fontSize: "4rem"
    },
    content: {
        color: theme.palette.primary.main,
        margin: "1rem 0",
        fontSize: "2rem"
    }
}), { name: "DployOverlayCircularProgress" });
export function OverlayCircularProgress(props) {
    const { children, pending = false, loading, error, pendingIconClass, errorIconClass, className } = props;
    const classes = useStyles(props);
    const pendingIcon = pendingIconClass ? (_jsx("i", { className: clsx(`fa fa-${pendingIconClass} fa-spin fa-fw`, classes.icon) })) : (_jsx(CircularProgress, { size: 38 }));
    const errorIcon = errorIconClass ? (_jsx("i", { className: clsx(`fa fa-${errorIconClass} fa-spin fa-fw`, classes.icon) })) : (_jsx(WarningIcon, {}));
    return (_jsx(Dialog, { fullScreen: true, open: true, PaperProps: {
            classes: {
                root: clsx(className, classes.paper)
            }
        }, BackdropProps: {
            classes: {
                root: classes.backdrop
            }
        }, children: _jsxs(DialogContent, { className: classes.container, children: [pending || loading ? pendingIcon : error ? errorIcon : null, _jsxs(DialogContentText, { className: classes.content, children: [(typeof error !== "string" && error && error.message) || error || (_jsx(FormattedMessage, { id: "dealer.overlay.loadingLabel", description: "Label for loading overlay", defaultMessage: "Please wait" })), children] })] }) }));
}
OverlayCircularProgress.displayName = "DployOverlayCircularProgress";
//# sourceMappingURL=OverlayCircularProgress.js.map